"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Button = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/Button"));
var _react = _interopRequireWildcard(require("react"));
const _excluded = ["onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const AsyncButton = (_ref, ref) => {
  let {
      onClick
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    0: loading,
    1: setLoading
  } = (0, _react.useState)(false);
  const asyncOnClick = (0, _react.useCallback)(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async e => {
    setLoading(true);
    // eslint-disable-next-line @typescript-eslint/await-thenable
    await onClick?.(e);
    setLoading(false);
  }, [onClick]);
  return __jsx(_Button.default, (0, _extends2.default)({}, props, {
    ref: ref,
    submitting: loading,
    onClick: asyncOnClick
  }));
};
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(AsyncButton);